import React, { useEffect, useState } from 'react'
import { Grid, Column, Row } from '../../../Grid'
import { groupBy } from 'lodash'

export default function CustomLegend({ data }) {
  const [windowWidth, setWidth] = useState(window.innerWidth)
  useEffect(() => {
    window.addEventListener('resize', () => setWidth(windowWidth))
  }, [window])

  const keys = Object.keys(groupBy(data, 'group'))
  return (
    <Grid className='custom-legend'>
      <Row>
        {keys.map((key, idx = 1) => (
          <Column className='bx--col-sm-1' key={`custom-legend-${key}-${idx}`}>
            {key}
          </Column>
        ))}
      </Row>
    </Grid>
  )
}
